import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'

// 全局 css
import './style/index.less'
// vant的css
import 'vant/lib/index.css'
import './assets/iccon/iconfont.css'
// 加载动态设置 REM 基准值
import 'amfe-flexible'
import 'vue-easytable/libs/theme-default/index.css'
import VueEasytable from 'vue-easytable'

// 虚拟滚动
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

// 批量注册所有公共组件（包括 FloatingBack）
import '@/components'

// --- 开启 Eruda 调试工具 (开始) ---
// if (process.env.NODE_ENV !== 'production') { // 只在非生产环境开启
//   const eruda = require('eruda')
//   // eslint-disable-next-line no-unused-vars
//   const _eruda = eruda.init() // Eruda 需要通过 init() 初始化
// }
// --- 开启 Eruda 调试工具 (结束) ---

Vue.use(VueEasytable)
Vue.use(Vant)
Vue.use(VueVirtualScroller)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
